import React from 'react'
import { ApartmentOutlined } from '@ant-design/icons';

const clampPercentage = (value) => {
    const numericValue = Number(value);

    if (Number.isNaN(numericValue)) {
        return 0;
    }

    return Math.min(100, Math.max(0, Math.round(numericValue)));
};

const CurrentPlanCard = ({
    planName = 'Current Plan',
    tier = 'Free',
    price = '$0',
    subtitle = 'Per month',
    usageLabel = '1 user only',
    percentage = 100,
    onManageSubscription,
    manageSubscriptionLoading = false,
}) => {
    const progressPercentage = clampPercentage(percentage);

    return (
        <div className='myProfile-plan-card'>
            <div className='myProfile-card-top'>
                <div className='myProfile-card-heading-wrap'>
                    <div className='myProfile-card-heading-row'>
                        <div className='myProfile-card-title'>{planName}</div>
                        <div className='myProfile-plan-badge'>{tier}</div>
                    </div>
                </div>
                {typeof onManageSubscription === 'function' ? (
                    <button
                        className='myProfile-manage-btn'
                        type='button'
                        onClick={manageSubscriptionLoading ? undefined : onManageSubscription}
                    >
                        <ApartmentOutlined />
                        <span>{manageSubscriptionLoading ? 'Loading...' : 'Manage Subscription'}</span>
                    </button>
                ) : null}
            </div>

            <div className='myProfile-plan-price'>{price}</div>
            <div className='myProfile-plan-subtitle'>{subtitle}</div>

            <div className='myProfile-plan-progress'>
                <div
                    className='myProfile-plan-progress-fill'
                    style={{ width: `${progressPercentage}%` }}
                />
            </div>

            <div className='myProfile-plan-footnote'>{usageLabel}</div>
        </div>
    );
};

export default CurrentPlanCard;
